/** Presentation routes only; no procurement readiness or Run-state decisions. */
export const workspaceSurface = (state, projects) => {
  const projectId = projects.projection?.scope.projectId;
  const draft = projects.sidebarNavigation?.conversationDraft;
  const routes = [
    { matches: state.lifecycle.status !== 'ready', surface: 'pending' },
    { matches: !projectId, surface: 'project_directory' },
    { matches: Boolean(state.session.sessionId), surface: 'conversation' },
    { matches: draft?.status === 'active' && draft.projectId === projectId, surface: 'conversation_draft' },
    { matches: true, surface: 'project_collection' },
  ];
  return routes.find(route => route.matches).surface;
};
